import React from 'react';
import { Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { SHARE_DELETED_ALERT_MESSAGE } from 'global/utils/loginRedirect';

// PFM-2640: in-place standalone screen shown when a redeemed share link resolves
// but the underlying shared assessment has been deleted. Rendered for BOTH
// anonymous and logged-in-without-normal-access viewers (i.e. anyone in a hashed
// view), so we must NOT tear down the hash session or redirect — clearing the
// hash token triggers the App.js anonymous-logout guard, which hard-navigates to
// the login page and drops the message. Keeping the viewer pinned here with the
// hash token intact is what lets this copy render at all.
//
// Styling mirrors the ShareRedemptionRoute error screen for visual consistency.
const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '60vh',
  gap: theme.spacing(2),
  padding: theme.spacing(4),
  textAlign: 'center',
}));

export default function ShareDeletedMessage() {
  return (
    <Root>
      <Typography variant="h5">{SHARE_DELETED_ALERT_MESSAGE}</Typography>
    </Root>
  );
}
